/**
 * Created by Mikhail Menshenin on 20.08.2024
 */

cleverapps.Plot.onStartup = function (f, returnClassOnly) {
    if (cleverapps.meta.getSelectedLocation().village.isFirstInit()) {
        return this.onFirstInit(f, returnClassOnly);
    }

    if (returnClassOnly) {
        return {
            scene: GameScene,
            options: [{ level: new Level(0, 0) }]
        };
    }

    CoinKingdom.OpenSlotMachine(f);
};

cleverapps.Plot.onFirstInit = function (f, returnClassOnly) {
    if (returnClassOnly) {
        return cleverapps.meta.getMainScene();
    }

    cleverapps.meta.gotoMainLocation(f);
};
